<template>
  <div ref="productsList" class="py-4 lg:py-6 xl:py-8 px-2 md:px-4 max-w-7xl mx-auto" :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }">
    <div class="flex flex-wrap">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductsList',
  metaInfo: {
    meta: [
      { vmid: 'title', property: 'og:title', content: 'LiveABC 互動英語教學集團|數位語言學習第一品牌' },
      { vmid: 'description', name: 'description', content: 'LiveABC的集團事業版圖橫跨出版、教育及數位內容等產業，提供全方位數位語言學習產品，出版ABC互動英語、Live互動英語、ALL+互動英語、CNN互動英語、互動日本語、知識大圖解(How It Works)系列雜誌刊物，以及各式叢書、教科書、線上學習平台等服務，並整合了LiveABC點讀筆、電腦影音互動學習軟體等學習工具，滿足各階段的學習需求。' },
      { vmid: 'og:description', property: 'og:description', content: 'LiveABC的集團事業版圖橫跨出版、教育及數位內容等產業，提供全方位數位語言學習產品，出版ABC互動英語、Live互動英語、ALL+互動英語、CNN互動英語、互動日本語、知識大圖解(How It Works)系列雜誌刊物，以及各式叢書、教科書、線上學習平台等服務，並整合了LiveABC點讀筆、電腦影音互動學習軟體等學習工具，滿足各階段的學習需求。' }
    ]
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
